import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import Report from '../Report.vue';
import PercentageStackedBarChart from '../chartjs/PercentageStackedBarChart.vue';
import BarChart from '../chartjs/BarChart.vue';
import LineChart from '../chartjs/LineChart.vue';
import { Data, Series } from '../../models';
import { ChartType } from '../../models/chartType';
import { computed, PropType, ref } from 'vue';
import { useReportData } from '@/features/reports/util/useReportData';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactTrendCharts',
  props: {
  data: {
    type: [Object, undefined] as PropType<Data | undefined>,
    required: false,
  },
  loadedData: {
    type: Boolean,
    default: false,
  },
  loadingError: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const { reportId, isDataLoaded, isDataEmpty, createBlankSeries } = useReportData(props);
const seriesOrder = ['Leads', 'Users'];

const chartType = ref(ChartType.BAR);
const reportData = computed(() => {
  return {
    scale: props.data.scale,
    series: seriesOrder.map(
      (seriesName) => props.data?.series.find((s: Series) => s.name === seriesName) || createBlankSeries(seriesName),
    ),
  };
});

const showLineChart = computed(() => chartType.value === ChartType.LINE);
const showBarChart = computed(() => chartType.value === ChartType.BAR);
const showPercentageBarChart = computed(() => chartType.value === ChartType.PERCENTAGE_BAR);

const switchBarChart = () => (chartType.value = ChartType.BAR);
const switchLineChart = () => (chartType.value = ChartType.LINE);
const switchStackedChart = () => (chartType.value = ChartType.PERCENTAGE_BAR);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(Report, {
    "report-id": _unref(reportId),
    title: "New Contacts",
    "tooltip-text": "A trend showing the number of recently created contacts, split by whether they are currently a lead or a user",
    class: "chart-container",
    dataEmpty: _unref(isDataEmpty),
    loadedData: _unref(isDataLoaded),
    loadingError: __props.loadingError
  }, {
    "header-addons": _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["button", { 'is-static': showLineChart.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (switchLineChart()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "chart-line" })
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["button percent-button", { 'is-static': showPercentageBarChart.value }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (switchStackedChart()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "percent" })
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["button", { 'is-static': showBarChart.value }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (switchBarChart()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "chart-bar" })
      ], 2)
    ]),
    chart: _withCtx(() => [
      (showLineChart.value)
        ? (_openBlock(), _createBlock(LineChart, {
            key: 0,
            reportId: _unref(reportId),
            class: "chart",
            data: reportData.value,
            fill: false,
            allowDecimalTicksY: false,
            seriesOrder: seriesOrder
          }, null, 8, ["reportId", "data"]))
        : _createCommentVNode("", true),
      (showPercentageBarChart.value)
        ? (_openBlock(), _createBlock(PercentageStackedBarChart, {
            key: 1,
            reportId: _unref(reportId),
            class: "chart",
            data: reportData.value,
            seriesOrder: seriesOrder
          }, null, 8, ["reportId", "data"]))
        : _createCommentVNode("", true),
      (showBarChart.value)
        ? (_openBlock(), _createBlock(BarChart, {
            key: 2,
            reportId: _unref(reportId),
            class: "chart",
            data: reportData.value,
            seriesOrder: seriesOrder
          }, null, 8, ["reportId", "data"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["report-id", "dataEmpty", "loadedData", "loadingError"]))
}
}

})